import script from "./heightAndPitchGauge.vue?vue&type=script&setup=true&lang=js"
export * from "./heightAndPitchGauge.vue?vue&type=script&setup=true&lang=js"

import "./heightAndPitchGauge.vue?vue&type=style&index=0&id=25ad85d1&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ad85d1"]])

export default __exports__